 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		9: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"1bfc9850","3":"9e0d663f50bcb1675764174325c5f5f6ead62312","4":"d7eeaac4","5":"9cf69bc4a6532c9a40f9eba2b267468bafabd430","6":"456d7783952268fd57f40c18b67fdc1c55e13b7c","7":"97d24738b3768d117a3a0bba34f466bdcbce63ab","8":"ceb15ab9cad3042ad8bba790f36d333f19b8a415","11":"component---src-pages-advancement-initiative-companies-tsx","12":"component---src-pages-advancement-initiative-index-tsx","13":"component---src-pages-advancement-initiative-partners-tsx","14":"component---src-pages-best-managed-companies-playbook-tsx","15":"component---src-pages-blog-tsx","16":"component---src-pages-companies-tsx","17":"component---src-pages-content-tsx","18":"component---src-pages-ecommerce-shopify-saas-tsx","19":"component---src-pages-environment-tsx","20":"component---src-pages-esg-tsx","21":"component---src-pages-index-tsx","22":"component---src-pages-insights-tsx","23":"component---src-pages-mental-health-tsx","24":"component---src-pages-post-tsx","25":"component---src-pages-privacy-tech-tsx","26":"component---src-pages-purpose-tsx","27":"component---src-pages-research-advancement-initiative-tsx","28":"component---src-pages-research-tsx","29":"component---src-pages-restaurant-tech-tsx","30":"component---src-pages-social-governance-tsx","31":"component---src-pages-team-tsx","32":"component---src-pages-terms-of-use-tsx","33":"component---src-pages-vc-diversity-pledge-tsx","34":"component---src-templates-research-detail-tsx","35":"e38bad9d"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"2d414def2c818a7ab4f2","2":"1ff69943cca0c22084e0","3":"49245758d5c1bd03a60d","4":"b21f13269254b3e21dd9","5":"7838c3c0d49d12031a47","6":"26b1a094c930ff46af3e","7":"a797a28590e664c3f320","8":"beaf53ada8bb1819aa6e","11":"5c79e8dcf553df89d381","12":"7dd1cdab648267a1fd16","13":"24f31e42046d8f4ee7a4","14":"ff85484a74847d24bbb6","15":"ebc4758dd8fff8fa7da3","16":"56c8cbc6a035cfdb44ef","17":"d5fbaac8d0cdbaee59b4","18":"e736ca3ab52ea357c543","19":"9b3bc06537fc11e15910","20":"8c333590fa025ad8655a","21":"440a2ab4b00dfbf0df10","22":"6e52f571ff4036b18740","23":"7db92a367df2efadd9f1","24":"356b330be9c990d93bf3","25":"7c8185001b5971df1eac","26":"51471d80e10a91c52736","27":"33d387cba64c2afa9ba3","28":"93f7e677a10de8aae1e0","29":"07802e745e7e6266bc80","30":"420befbfb019e6619664","31":"7774eec99ae3cccbc7cf","32":"bfc1619677d4a827f70b","33":"ea3693a9c15b9a8a1117","34":"0ceb5309da5bfc738599","35":"8ffddd38ee0751738ff3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"1bfc9850","3":"9e0d663f50bcb1675764174325c5f5f6ead62312","4":"d7eeaac4","5":"9cf69bc4a6532c9a40f9eba2b267468bafabd430","6":"456d7783952268fd57f40c18b67fdc1c55e13b7c","7":"97d24738b3768d117a3a0bba34f466bdcbce63ab","8":"ceb15ab9cad3042ad8bba790f36d333f19b8a415","11":"component---src-pages-advancement-initiative-companies-tsx","12":"component---src-pages-advancement-initiative-index-tsx","13":"component---src-pages-advancement-initiative-partners-tsx","14":"component---src-pages-best-managed-companies-playbook-tsx","15":"component---src-pages-blog-tsx","16":"component---src-pages-companies-tsx","17":"component---src-pages-content-tsx","18":"component---src-pages-ecommerce-shopify-saas-tsx","19":"component---src-pages-environment-tsx","20":"component---src-pages-esg-tsx","21":"component---src-pages-index-tsx","22":"component---src-pages-insights-tsx","23":"component---src-pages-mental-health-tsx","24":"component---src-pages-post-tsx","25":"component---src-pages-privacy-tech-tsx","26":"component---src-pages-purpose-tsx","27":"component---src-pages-research-advancement-initiative-tsx","28":"component---src-pages-research-tsx","29":"component---src-pages-restaurant-tech-tsx","30":"component---src-pages-social-governance-tsx","31":"component---src-pages-team-tsx","32":"component---src-pages-terms-of-use-tsx","33":"component---src-pages-vc-diversity-pledge-tsx","34":"component---src-templates-research-detail-tsx","35":"e38bad9d"}[chunkId]||chunkId) + "." + {"0":"2a7367b58e9d592ab267","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
